export default ({ request }) => ({
  customerRiskCheckListApi(data) {
    return request({
      url: '/digitalCenter/customer/risk/check/list',
      method: 'post',
      data,
    })
  },
  customerRiskCheckDetailApi(data) {
    return request({
      url: '/digitalCenter/customer/risk/check/detail',
      method: 'post',
      data,
    })
  },
  customerRiskCheckAddApi(data) {
    return request({
      url: '/digitalCenter/customer/risk/check/add',
      method: 'post',
      data,
    })
  },
  customerRiskCheckSaveApi(data) {
    return request({
      url: '/digitalCenter/customer/risk/check/save',
      method: 'post',
      data,
    })
  },
  customerRiskCheckSubmitApi(data) {
    return request({
      url: '/digitalCenter/customer/risk/check/submit',
      method: 'post',
      data,
    })
  },
  customerRiskCheckDocListApi(data) {
    return request({
      url: '/digitalCenter/customer/risk/check/doc/list',
      method: 'post',
      data,
    })
  },
  customerRiskCheckDocUploadApi(data) {
    return request({
      url: '/digitalCenter/customer/risk/check/doc/upload',
      method: 'post',
      data,
    })
  },
  customerRiskCheckDocDelApi(data) {
    return request({
      url: '/digitalCenter/customer/risk/check/doc/del',
      method: 'post',
      data,
    })
  },
})
